// src/pages/Admin/SemestersCreate.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function SemestersCreate() {
  const [semesterName, setSemesterName] = useState('');
  const [tooltip, setTooltip] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/semesters', { name: semesterName });
      setTooltip('Semester created successfully!');
      setTimeout(() => navigate('/admin/semesters/view'), 2000);
    } catch (err) {
      setTooltip('Error creating semester.');
    }
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create New Semester" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Semester Name</label>
              <input 
                type="text" 
                className="form-control"
                value={semesterName}
                onChange={(e) => setSemesterName(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Create Semester</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SemestersCreate;
